var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_2197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.067 82.0667C156.067 41.1976 122.936 8.06665 82.0669 8.06665C41.1978 8.06665 8.06689 41.1976 8.06689 82.0667C8.06689 122.936 41.1978 156.067 82.0669 156.067C122.936 156.067 156.067 122.936 156.067 82.0667Z",
    fill: "#00397D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.107 77.116C115.922 77.3826 115.687 77.6102 115.415 77.7858C115.142 77.9614 114.838 78.0817 114.519 78.1396C114.2 78.1976 113.873 78.1921 113.556 78.1236C113.24 78.055 112.94 77.9247 112.673 77.7401L83.4308 57.4863C83.0182 57.2004 82.5281 57.0472 82.026 57.0472C81.524 57.0472 81.0339 57.2004 80.6213 57.4863L51.4505 77.7253C51.1844 77.9101 50.8845 78.0407 50.5679 78.1096C50.2513 78.1785 49.9243 78.1843 49.6055 78.1269C49.2866 78.0694 48.9822 77.9496 48.7097 77.7745C48.4371 77.5994 48.2017 77.3723 48.0169 77.1062C47.8321 76.8401 47.7015 76.5402 47.6326 76.2236C47.5637 75.907 47.5578 75.58 47.6153 75.2611C47.6728 74.9423 47.7925 74.6379 47.9677 74.3653C48.1428 74.0928 48.3699 73.8574 48.636 73.6726L77.8068 53.4336C79.047 52.5803 80.517 52.1234 82.0224 52.1234C83.5277 52.1234 84.9977 52.5803 86.2379 53.4336L115.493 73.6874C115.759 73.8718 115.987 74.1069 116.162 74.3792C116.338 74.6516 116.458 74.956 116.516 75.2748C116.574 75.5937 116.569 75.9209 116.5 76.2377C116.432 76.5544 116.301 76.8546 116.117 77.121L116.107 77.116ZM105.905 76.9039L83.4283 61.8572C83.0225 61.5857 82.5452 61.4408 82.0569 61.4408C81.5686 61.4408 81.0913 61.5857 80.6854 61.8572L58.2091 76.9039C57.2002 77.5812 56.3736 78.4965 55.8023 79.569C55.231 80.6414 54.9326 81.8381 54.9334 83.0533V104.612C54.9334 106.575 55.7131 108.457 57.1008 109.845C58.4886 111.232 60.3708 112.012 62.3334 112.012H72.2001V97.212C72.2001 95.2494 72.9797 93.3671 74.3675 91.9794C75.7553 90.5916 77.6375 89.812 79.6001 89.812H84.5334C86.496 89.812 88.3782 90.5916 89.766 91.9794C91.1538 93.3671 91.9334 95.2494 91.9334 97.212V112.012H101.8C103.763 112.012 105.645 111.232 107.033 109.845C108.42 108.457 109.2 106.575 109.2 104.612V83.0533C109.2 81.8372 108.9 80.64 108.327 79.5674C107.754 78.4948 106.925 77.58 105.914 76.9039H105.905ZM109.2 57.7453C109.2 56.4369 108.68 55.1821 107.755 54.2569C106.83 53.3317 105.575 52.812 104.267 52.812H101.8C100.94 52.8137 100.096 53.041 99.3513 53.4713C98.6068 53.9015 97.9882 54.5196 97.5574 55.2638L109.2 63.3249V57.7453Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_2197",
    x: 0.0668945,
    y: 0.0666504,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.325 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_2197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_2197",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a7d5b8f5c921e04cb4f62028fe4dd60d.svg";
export { ForwardRef as ReactComponent };